function CheckLiteCart() {
    console.log("p4t CheckLiteCart");

    if (document.p4t_punchout) {
        var carts = document.p4t_punchout.cart_id.value.split(',');
        var checked = [];
        for (var i = 0; i < carts.length; i++) {
            if (carts[i])
                if (document.simulatecartform['simulate_checkbox_' + carts[i]].checked) {
                    checked.push(carts[i]);
                }
        }
        console.log("p4t CheckLiteCart checked length " + checked.length);
        if (checked.length === 1) {
            document.p4t_punchout.cart_id.value = checked.join();
            document.p4t_punchout.full_cart.value = 1;
            openP4tPunchoutCall();
            return true;
        } else if (checked.length > 1) {
            return false;
        }
    }
    return true;
}
function p4t_punchoutFormSubmit(request_id)
{
    document.p4t_punchout_form.request_id.value = request_id;
    document.p4t_punchout_form.submit();
}

function openP4tPunchoutCall() {
    console.log("openP4tPunchoutCall");

    const form = document.forms['p4t_punchout'];
    const formData = $(form).serialize();

    console.log("formData call");
    console.log(formData);

    loadP4tAssetsIfNeeded(function () {
        $('#p4tSourcingModal').modal('show');

        $.ajax({
            url: 'ports/curecomp/p4t_put_rfq.php',
            method: 'POST',
            data: formData,
            success: function(response) {
                $('#p4tSourcingModal .modal-content').html(response);
            },
            error: function() {
                $('#p4tSourcingModal .modal-content').html(
                    '<div class="text-danger p-3">Fehler beim Laden des Punchout-Inhalts.</div>'
                );
            }
        });
    });
}

function closeP4tPunchoutSourcingCall() {
    $('#p4tSourcingModal').modal('close');
}

function handleSourcingSubmit(event) {
    event.preventDefault();
    console.log("Formular abgeschickt");
    closeP4tPunchoutCall();
}

function loadP4tAssetsIfNeeded(callback) {
    if (document.getElementById('p4t-assets-loaded')) {
        callback();
        return;
    }

    const head = document.getElementsByTagName('head')[0];

    const marker = document.createElement('meta');
    marker.id = 'p4t-assets-loaded';
    head.appendChild(marker);

    const useMin = window.p4t_use_min_version ? '.min' : '';
    const jsRandom = window.p4t_js_random || Math.floor(Math.random() * 10000);

    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'css/common.css'; // weitere CSS kannst du hier hinzufügen
    head.appendChild(css);

    const script1 = document.createElement('script');
    script1.src = 'js/jquery_dig.min.js';
    head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = `js/catalog${useMin}.js?rnd=${jsRandom}`;
    script2.onload = callback;

    head.appendChild(script2);
}




/**
 * 
 * @ EKLite cart-testing and -handling
 * @ Author: olbe, 21.08.2014
 *
 */
var oP4TCart =
        {
            iCheckedTot: 0,
            iNormalCount: 0,
            iEKLightCount: 0,
            iNormalChecked: 0,
            iEKLightChecked: 0,
            //uncheck all carts if not single-origin
            firstUncheckCarts: function ()
            {
                if (document.p4t_punchout) {
                    oP4TCart.countCarts();

                    if (oP4TCart.iEKLightCount > 1 ||
                            (oP4TCart.iEKLightCount > 0 && oP4TCart.iNormalCount > 0)) {
                        $("input[name*='simulate_checkbox_']").each(function (idx) {
                            this.checked = false;
                        });
                    }

                    oP4TCart.simulateCheckboxChange();
                }
            },
            // count all cart-variations
            countCarts: function ()
            {
                oP4TCart.iCheckedTot = 0;
                oP4TCart.iNormalCount = 0;
                oP4TCart.iEKLightCount = 0;
                oP4TCart.iNormalChecked = 0;
                oP4TCart.iEKLightChecked = 0;

                if (document.p4t_punchout) {
                    var aCartArr = document.p4t_punchout.cart_id.value.split(',');
                    oP4TCart.iEKLightCount = aCartArr.length - 1;

                    $("input[name*='simulate_checkbox_']").each(function (idx) {
                        if (this.checked) {
                            oP4TCart.iCheckedTot = oP4TCart.iCheckedTot + 1;
                        }
                        var aCurrID = this.name.split('_');
                        if (aCartArr.indexOf(aCurrID[2]) === -1) {
                            oP4TCart.iNormalCount = oP4TCart.iNormalCount + 1;
                            if (this.checked) {
                                oP4TCart.iNormalChecked = oP4TCart.iNormalChecked + 1;
                            }
                        } else {
                            if (this.checked) {
                                oP4TCart.iEKLightChecked = oP4TCart.iEKLightChecked + 1;
                            }
                        }
                    });
                } else {
                    $("input[name*='simulate_checkbox_']").each(function (idx) {
                        oP4TCart.iNormalCount = oP4TCart.iNormalCount + 1;
                        if (this.checked) {
                            oP4TCart.iNormalChecked = oP4TCart.iNormalChecked + 1;
                            oP4TCart.iCheckedTot = oP4TCart.iCheckedTot + 1;
                        }
                    });
                }
            },
            // get checked EKLight-CartId
            getEKLightCartId: function ()
            {
                var sEKLightCartId = "";
                if (document.p4t_punchout) {
                    var aCartArr = document.p4t_punchout.cart_id.value.split(',');

                    $("input[name*='simulate_checkbox_']").each(function (idx) {
                        var aCurrID = this.name.split('_');
                        if (aCartArr.indexOf(aCurrID[2]) === -1) {
                        } else {
                            if (this.checked) {
                                sEKLightCartId = aCurrID[2];
                            }
                        }
                    });
                }

                return sEKLightCartId;
            },
            // check if button is disabled
            isDisabled: function (sElementName)
            {
                console.log("oP4TCart isDisabled");
                $(sElementName).blur();

                return $(sElementName).hasClass('buttonDisabled');
            },
            // enable Button
            enableButton: function (sElementName)
            {
                try {
                    $(sElementName).removeClass("buttonDisabled disabled");
                } catch (e) {
                }
            },
            // disable Button
            disableButton: function (sElementName)
            {
                try {
                    $(sElementName).addClass("buttonDisabled disabled");
                } catch (e) {
                }
            },
            // on change-event of cart-checkbox
            simulateCheckboxChange: function ()
            {
                oP4TCart.countCarts();

                if (oP4TCart.iCheckedTot === 0 || oP4TCart.iNormalChecked > 0 && oP4TCart.iEKLightChecked > 0) {
                    oP4TCart.disableButton("#goto_p4t");
                    oP4TCart.disableButton("#submit_cart");
                }
                if (oP4TCart.iEKLightChecked === 1 && oP4TCart.iNormalChecked === 0) {
                    oP4TCart.enableButton("#goto_p4t");
                    oP4TCart.disableButton("#submit_cart");
                }
                if (oP4TCart.iNormalChecked > 0 && oP4TCart.iEKLightChecked === 0) {
                    oP4TCart.disableButton("#goto_p4t");
                    oP4TCart.enableButton("#submit_cart");
                }
            },
            checkCallback: function (sUrl, oInterval, sCartId)
            {
                if (sCartId === null || sCartId === "" || sCartId === "0") {
                    clearInterval(oInterval);
                    return 'NOTHING';
                }
                $.ajax({
                    type: "POST",
                    url: sUrl,
                    data: {
                        cartid: sCartId
                    },
                    success: function (sResponseData) {
                        if (sResponseData === 'DONE') {
                            clearInterval(oInterval);

                            try {
                                document.deliveredamounts.rightchangeamounts.value = '';
                            } catch (e) {
                            }
                            deliveredAmountsCart(sCartId, '');
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        clearInterval(oInterval);
                        return 'ERROR';
                    }
                });

                return 'NOTHING';
            },
            doQuotCountOK: function (sUrl, okFunction, failFunction)
            {
                var sCartArticleIds = '';
//    $("input[name*='checkcartarticle']").each(function(idx) {
                $("input[name*='orderposnum']").each(function (idx) {
//      if (this.checked) {
                    sCartArticleIds += this.name.replace('orderposnum', '') + ',';
//      }
                });
                if (sCartArticleIds !== '') {
                    sCartArticleIds = sCartArticleIds.substr(0, sCartArticleIds.length - 2);

                    $.ajax({
                        type: "POST",
                        url: sUrl,
                        data: {
                            cart_article_ids: sCartArticleIds
                        },
                        success: function (sResponseData) {
                            if (parseInt(sResponseData) === 1) {
                                if (typeof (okFunction) === 'function') {
                                    okFunction();
                                }
                            } else {
                                if (typeof (failFunction) === 'function') {
                                    failFunction();
                                }
                            }
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            if (typeof (failFunction) === 'function') {
                                failFunction();
                            }
                        }
                    });
                } else {
                    if (typeof (failFunction) === 'function') {
                        failFunction();
                    }
                }
            }
        };

